import { validationLength } from "../components/actions/validations";

const categoryMax = validationLength.categoryName;
const notesMax = validationLength.reservationGuestNotesText;

const spaceRule = (max: number) =>
  `Max ${max} characters; letters, numbers and spaces only; no special characters.`;

const nameRule = (max: number) =>
  `Max ${max} characters; line breaks not allowed.`;

/** Shown above Reservation notes — either/or rule. */
export const reserveReservationGuestNotesSectionNotice =
  "Enter either Reservation notes or Guest notes for this row — not both.";

/** Default (non-error) helper text under Reservation Guest Notes fields. */
export const reserveReservationGuestNotesFieldHelperText = {
  category: `${spaceRule(categoryMax)} Mandatory.`,
  subcategory: `${spaceRule(categoryMax)} Optional.`,
  reservationNotes: `${nameRule(notesMax)} Optional; do not use with Guest notes.`,
  guestNotes: `${nameRule(notesMax)} Optional; do not use with Reservation notes.`,
} as const;

/** Error helper text (shown in red when field validation fails). */
export const reserveReservationGuestNotesFieldErrors = {
  required: "This field is required.",
  category: spaceRule(categoryMax),
  subcategory: spaceRule(categoryMax),
  reservationNotes: nameRule(notesMax),
  guestNotes: nameRule(notesMax),
  mutualExclusive: "Enter either Reservation notes or Guest notes — not both.",
} as const;
